import ProviderSetup from './provider-setup';

const message = (key, fallback) => ({ key, fallback });

const config = {
  id: 'chatgpt',
  name: 'ChatGPT',
  description: message('chatgpt_page_description', 'Manage your Brand2Social content from ChatGPT and Codex.'),
  introduction: message('chatgpt_introduction', 'Use natural language to review your social activity, prepare content and submit posts through your existing Brand2Social workflow.'),
  openUrl: 'https://chatgpt.com',
  openLabel: message('open_chatgpt', 'Open ChatGPT'),
  tabs: [
    {
      label: message('chatgpt_web', 'ChatGPT Web'),
      steps: [
        { title: message('chatgpt_step1_title', 'Open ChatGPT settings'), description: message('chatgpt_step1_description', 'Open ChatGPT, then go to Settings and find Apps & Connectors.') },
        { title: message('chatgpt_step2_title', 'Enable Developer mode'), description: message('chatgpt_step2_description', 'Open Advanced settings and enable Developer mode for custom MCP applications.') },
        { title: message('chatgpt_step3_title', 'Create a new app'), description: message('chatgpt_step3_description', 'Choose Create app, enter Brand2Social as the name, paste the MCP server URL below and select OAuth.') },
        { title: message('chatgpt_step4_title', 'Approve access'), description: message('chatgpt_step4_description', 'Create the app, sign in to Brand2Social, choose your organization and approve the requested read or write access.') },
      ],
    },
    {
      label: message('codex', 'Codex'),
      steps: [
        { title: message('codex_step1_title', 'Open MCP settings'), description: message('codex_step1_description', 'Open the MCP configuration in Codex.') },
        { title: message('codex_step2_title', 'Add a remote server'), description: message('codex_step2_description', 'Create a Streamable HTTP MCP connection and use the Brand2Social server URL below.') },
        { title: message('codex_step3_title', 'Use OAuth'), description: message('codex_step3_description', 'Start browser authorization and sign in to your Brand2Social account.') },
        { title: message('codex_step4_title', 'Approve the organization'), description: message('codex_step4_description', 'Choose the organization that Codex may access and approve the requested permissions.') },
      ],
    },
  ],
  prompts: [
    message('chatgpt_prompt1', 'Show my scheduled posts for this week.'),
    message('chatgpt_prompt2', 'List failed posts and explain their failure reasons.'),
    message('chatgpt_prompt3', 'Create an Instagram draft for our weekend offer.'),
  ],
};

export default function ChatGPTConnection() {
  return <ProviderSetup config={config} />;
}
